/**
 * 系统管理  权限管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="float: left;margin-top: 20px;">
      <el-button type="primary" size="mini" @click="saveSeting">保存设置</el-button>
      <el-table ref="roleTable" v-loading="gloading" :data="roletable" border highlight-current-row @current-change="handleCurrentChange" style="width: 180px;margin-top: 20px;">
        <el-table-column prop="gname" label="角 色" width="179" align="center">
        </el-table-column>
      </el-table>
    </div>
    <div style="float: left;margin-left: 60px;width: 300px;margin-top: 40px;">
      <el-tree ref="tree" :data="authdata" show-checkbox :default-expanded-keys="expanded" :default-checked-keys="checked" node-key="id">
      </el-tree>
    </div>
  </div>
</template>

<script>
  import { roleList,authList,saveAuth } from '../../api/baseset'
  export default {
    data() {
      return {
        gloading: false,
        roletable: [],
        currentRow: [],
        authdata: [],
        expanded: [],
        checked: []
      }
    },
    created() {
      this.getroleData();
    },
    methods: {
      getroleData() {
        this.gloading = true
        roleList().then(res => {
          this.gloading = false
          this.roletable = res.data
          this.setCurrent(this.roletable[0])
          this.getAuthTree();
        })
      },
      getAuthTree() {
        const data = {gid:this.currentRow.id}
        authList(data).then(res => {
          this.authdata = res.data.list;
          this.expanded = res.data.expanded;
          this.checked = res.data.checked;
        })
      },
      setCurrent(row) {
        this.$refs.roleTable.setCurrentRow(row);
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        this.getAuthTree();
      },
      saveSeting() {
        const checked = this.$refs.tree.getCheckedKeys();
        const data = {gid:this.currentRow.id,rules:checked.join(',')}
        saveAuth(data).then(res => {
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message.error(res.msg);
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/system/Permission.vue